import { useReportTransport } from "@/reports"

interface ReportBreadcrumbContentProps {
  reportId: string
  isLast: boolean
}

export function ReportBreadcrumbContent({
  reportId,
  isLast,
}: ReportBreadcrumbContentProps) {
  const { data } = useReportTransport(reportId, {
    enabled: !!reportId && reportId.length === 26,
  })

  const displayName = data?.display_name || reportId

  return <span className={isLast ? "font-semibold" : ""}>{displayName}</span>
}
